import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { fetchAdminDefaultTasks } from '../../../../features/adminSlice'
import { TaskConfigDetails } from './TaskConfigDetails'
import styles from '../AdminConfigsPage.module.scss'

export function DefaultTasksPage() {
	const dispatch = useDispatch()
	const defaultTasks = useSelector((s) => s.admin.defaultTasks)
	const loading = useSelector((s) => s.admin.defaultTasksLoading)
	const error = useSelector((s) => s.admin.defaultTasksError)

	useEffect(() => {
		dispatch(fetchAdminDefaultTasks())
	}, [dispatch])

	return (
		<div className={styles.panelCard} data-cy="admin-default-tasks">
			<Link
				to="/admin/configs/wedding-tasks"
				className={styles.backLink}
				data-cy="admin-back-to-wedding-types"
			>
				← Back to wedding types
			</Link>
			<Typography component="h2" className={styles.panelTitle}>
				All default tasks
			</Typography>
			<p className={styles.panelBody}>
				Canonical task definitions from <code>TaskConfig</code> (default
				notification copy and scheduling windows).
			</p>
			{loading && <p className={styles.panelBody}>Loading…</p>}
			{error && <p className={styles.errorText}>{error}</p>}
			{!loading && !error && defaultTasks?.length === 0 && (
				<p className={styles.panelBody}>
					No default tasks found. Run{' '}
					<code>cd server && npm run pop</code> after starting the
					server.
				</p>
			)}
			{defaultTasks?.map((task) => (
				<Accordion
					key={task.taskId}
					className={styles.taskAccordion}
					data-cy={`admin-default-task-accordion-${task.taskId}`}
				>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography className={styles.accordionSummary}>
							{task.task || task.taskId}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<TaskConfigDetails task={task} />
					</AccordionDetails>
				</Accordion>
			))}
		</div>
	)
}
